import { NgModule } from '@angular/core';
import {
    zeroInitPipe,
    currencyToNumberPipe,
    firstMayusPipe,
    firstMinusPipe,
    MXCurrencyPipe,
    tagAmountMaxPipe,
    sentenceCasePipe,
    formattedLCPipe,
    objLengthPipe,
    texTruncatePipe,
    MoneyFormatPipe,
    MaskContractPipe
} from "@core/pipes/utils-pipe/utils-pipe.pipe";
@NgModule({
    declarations: [
        zeroInitPipe,
        currencyToNumberPipe,
        firstMayusPipe,
        firstMinusPipe,
        MXCurrencyPipe,
        tagAmountMaxPipe,
        sentenceCasePipe,
        formattedLCPipe,
        texTruncatePipe,
        objLengthPipe,
        MoneyFormatPipe,
        MaskContractPipe
    ],
    exports: [
        zeroInitPipe,
        currencyToNumberPipe,
        firstMayusPipe,
        firstMinusPipe,
        MXCurrencyPipe,
        tagAmountMaxPipe,
        sentenceCasePipe,
        formattedLCPipe,
        texTruncatePipe,
        objLengthPipe,
        MoneyFormatPipe,
        MaskContractPipe
    ]
})
export class UtilsPipeModule { }
